import React, { useState, useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";
import { BlobProvider } from "@react-pdf/renderer";

import PreviewPdf from "../PreviewPdf";

import "./index.css";

function PreviewModal(props) {
  const [open, setOpen] = useState(props.isOpen);

  useEffect(() => {
    if (open !== props.isOpen) {
      setOpen(props.isOpen);
    }
  }, [props.isOpen]); //eslint-disable-line

  function handleOnHide() {
    if (props.onClose) {
      props.onClose();
    } else {
      handleClose();
    }
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <Modal
      style={{
        width: "95%",
        maxWidth: "none",
        height: "100%",
        margin: "auto",
        display: "flex",
        alignItems: "center",
      }}
      isOpen={open}
      toggle={handleOnHide}
      backdrop="static"
      size="lg"
      className="mx-auto"
    >
      <div style={{ padding: "15px", paddingBottom: 0 }}>
        <div className="d-flex align-items-center justify-content-end">
          {/* <p style={{ fontSize: "1.5em", fontWeight: "bold" }}>Preview Form</p> */}
          <div>
            <img
              alt="close"
              onClick={handleOnHide}
              src={require("../../../../assets/icons/close.png")}
              style={{ width: "15px", cursor: "pointer" }}
            />
          </div>
        </div>
      </div>

      <ModalBody style={{ height: "85vh" }}>
        <div style={{ height: "100%" }}>
          {open && (
            <BlobProvider
              document={
                <PreviewPdf
                  name={props.name}
                  signature={props.signature}
                  picture={props.picture}
                  data={props.data}
                />
              }
            >
              {({ url }) => {
                if (url) {
                  return (
                    <iframe
                      title="rsa-nin"
                      style={{ width: "100%", height: "100%" }}
                      src={url}
                    ></iframe>
                  );
                }
                return null;
              }}
            </BlobProvider>
          )}
          {/* <PDFViewer style={{ width: "100%", height: "100%" }}>
            <PreviewPdf />
          </PDFViewer> */}
          {/* <iframe
            style={{ width: "100%", height: "100%" }}
            src={constants.PDF}
          ></iframe> */}
        </div>
      </ModalBody>
    </Modal>
  );
}

PreviewModal.defaultProps = {};

export default PreviewModal;
